module.exports = __webpack_public_path__ + "e59d32640b0023d4c484239b189e1f01.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-ExtraBoldItalic.ttf
// module id = 1253
// module chunks = 0